import { Box, Button, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { useEffect, useState } from 'react';
import FormFields from '../FormFields';

export const TypeToggelFieldsViaIcons = ({
  updateValidationOnChange,
  dataCollection,
  field,
  size,
  errors,
  validationSchema,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const cards = field.cards;

  const [currentFields, setCurrentFields] = useState([]);

  useEffect(() => {
    if (!cards || cards.length == 0) return;
    const selectedCard = cards.find(
      (card) => dataCollection[field.key] === card.value
    );
    if (selectedCard) handleSelect(selectedCard);
  }, []);

  function handleSelect(card) {
    updateValidationOnChange(field.key, card.value);

    setCurrentFields(card.formFields);
  }

  function handleFormFieldUpdate(data) {
    updateValidationOnChange([field.key], data, true);
  }

  return (
    <Box className="flex flex-col gap-4">
      <Box className="flex gap-2">
        {field.label && (
          <Box
            sx={{
              borderRadius: '12px',
              bgcolor: colors.bgInput,
            }}
            className="flex items-center px-[14px]"
          >
            {field.label}
          </Box>
        )}
        {cards.map((card) => (
          <Card
            key={card.value}
            card={card}
            isSelected={dataCollection[field.key] === card.value}
            onSelect={handleSelect}
          />
        ))}
      </Box>
      <FormFields
        fields={currentFields}
        dataCollection={dataCollection}
        updateDataCollection={handleFormFieldUpdate}
        validationSchema={validationSchema}
      />
    </Box>
  );
};

const Card = ({ card, isSelected, onSelect }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { Icon, label, value } = card;
  return (
    <Button
      onClick={() => onSelect(card)}
      className=" flex-col"
      sx={{
        border: `1px solid ${isSelected ? colors.info + '80' : 'transparent'}`,
        bgcolor: isSelected ? colors.info + '30' : colors.bgInput,
        padding: '4px 8px',
        minWidth: 'unset',
        height: '56px',
        width: '56px',
        minWidth: '56px',
        fontSize: '10px',
        ':hover': {
          bgcolor: colors.info + '30',
          border: `1px solid ${colors.info}80`,
        },
      }}
    >
      {Icon && <Icon sx={{ fontSize: '25px' }} />}
      {label}
    </Button>
  );
};
